export default {
  getCategoryIcon(iconName) {
    if (iconName == 'Advertising') {
      return 'Advertising'
    } else if (iconName == 'Equipment rent & lease') {
      return 'EquipmentRentLease'
    } else if (iconName == 'Fees') {
      return 'Fees'
    } else if (iconName == 'Home Office') {
      return 'HomeOffice'
    } else if (iconName == 'Insurance') {
      return 'Insurance'
    } else if (iconName == 'Meals & Entertainment') {
      return 'MealsEntertainment'
    } else if (iconName == 'Meals with clients') {
      return 'MealWithClients'
    } else if (iconName == 'Office Supplies') {
      return 'OfficeSupplies'
    } else if (iconName == 'Other Expenses') {
      return 'Other'
    } else if (iconName == 'Training & Education') {
      return 'TrainingEducation'
    } else if (iconName == 'Transportation') {
      return 'Transportation'
    } else if (iconName == 'Travel') {
      return 'Flights'
    } else if (iconName == 'Vehicle') {
      return 'Vehicle'
    } else {
      return 'None';
    }
  },
}